module.exports = __webpack_public_path__ + "img/logo-login.5f7c9c30.png";